import React, { Suspense, lazy, useEffect, useRef } from "react";

import "./App.scss";

import { useDispatch, useSelector } from "react-redux";
import { configActions, overlayActions } from "./store/redux/store";

import SearchOverlay from "./Components/Overlays/SearchOverlay/SearchOverlay";

const App = () => {
    let configAppID = useRef();
    let configSearchKey = useRef();
    let configSearchIndex = useRef();
    let configSearchIndexQuerySuggestions = useRef();
    let configSearchPriceAscIndex = useRef();
    let configSearchPriceDescIndex = useRef();
    let configSearchShippingTimeInDaysAscIndex = useRef();
    let configSearchShippingTimeInDaysDescIndex = useRef();
    let configDebounceTimeInMs = useRef();
    let configCharactersToTrigger = useRef();
    let configAlgoliaUserToken = useRef();
    let configAlgoliaButtonTextConfig = useRef();
    let configAlgoliaButtonTextAdd = useRef();

    const isSearchOpen = useSelector((state) => state.overlay.isSearchOpen);
    const initSearch = useSelector((state) => state.overlay.initSearch);
    const dispatch = useDispatch();
    const initSearchOverlay = () => {
        dispatch(overlayActions.initSearch());
    };
    const toggleSearchOverlay = () => {
        dispatch(overlayActions.toggleSearchOverlay());
    };
    const initConfig = () => {
        configAppID.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-applicationid");
        configSearchIndex.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-indexname");
        configSearchPriceAscIndex.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-indexname-price-asc");
        configSearchPriceDescIndex.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-indexname-price-desc");
        configSearchShippingTimeInDaysAscIndex.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-indexname-shippingTimeInDays-asc");
        configSearchShippingTimeInDaysDescIndex.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-indexname-shippingTimeInDays-desc");
        configSearchIndexQuerySuggestions.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-indexname-query-suggestions");
        configSearchKey.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-searchapikey");
        configDebounceTimeInMs.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-debouncetime");
        configCharactersToTrigger.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-triggeraftercharacters");
        configAlgoliaUserToken.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-usertoken");
        configAlgoliaButtonTextConfig.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-button-text-config");
        configAlgoliaButtonTextAdd.current = document
            .getElementById("algolia-config")
            .getAttribute("data-algolia-button-text-add");

        dispatch(
            configActions.initConfig({
                APP_ID: configAppID.current,
                SEARCH_KEY: configSearchKey.current,
                SEARCH_INDEX: configSearchIndex.current,
                SEARCH_PRICE_ASC_INDEX: configSearchPriceAscIndex.current,
                SEARCH_PRICE_DESC_INDEX: configSearchPriceDescIndex.current,
                SEARCH_SHIPPINGTIMEINDAYS_ASC_INDEX:
                    configSearchShippingTimeInDaysAscIndex.current,
                SEARCH_SHIPPINGTIMEINDAYS_DESC_INDEX:
                    configSearchShippingTimeInDaysDescIndex.current,
                SEARCH_INDEX_QUERY_SUGGESTIONS:
                    configSearchIndexQuerySuggestions.current,
                DEBOUNCE_TIME_MS: configDebounceTimeInMs.current,
                CHARACTERS_TO_TRIGGER: configCharactersToTrigger.current,
                INSIGHTS_USER_TOKEN: configAlgoliaUserToken.current,
                BUTTON_TEXT_CONFIG: configAlgoliaButtonTextConfig.current,
                BUTTON_TEXT_ADD: configAlgoliaButtonTextAdd.current
            }),
        );

        const pageBody = document.body;
        if (
            window.location.search.indexOf(configSearchIndex.current) > -1 ||
            window.location.search.indexOf("products") > -1
        ) {
            initSearchOverlay();
            toggleSearchOverlay();
            pageBody.classList.add("algolia-search-layer");
        }
    };
    useEffect(
        () => {
            const searchTrigger = document.getElementById("search--trigger");
            const pageBody = document.body;
            searchTrigger.onclick = (event) => {
                event.preventDefault();
                initSearchOverlay();
                toggleSearchOverlay();

                pageBody.classList.add("algolia-search-layer");
            };
            // shows the overlay if a search string is found
        },
        // eslint-disable-next-line
        [],
    );

    useEffect(() => {
        initConfig();
        // eslint-disable-next-line
    }, []);

    return <>{initSearch ? <SearchOverlay /> : null}</>;
};

export default App;
